export const EN_URL = "https://www.pingcap.com/?from=en"
export const JA_URL = "https://pingcap.co.jp/"
